import { getQueryStringValue } from "./url";

const getClientCoordinates = () => {
  const latOverride = getQueryStringValue("currentLocationLatitude");
  const lngOverride = getQueryStringValue("currentLocationLongitude");

  if (latOverride !== undefined && lngOverride !== undefined) {
    return {
      latitude: parseFloat(latOverride),
      longitude: parseFloat(lngOverride),
    };
  }

  // default coordinates are either an entity in path on page load or
  // otherwise the city center if no entity.
  const lat = Number(VisitWidget.settings.defaultCoordinates.latitude);
  const lng = Number(VisitWidget.settings.defaultCoordinates.longitude);

  return { latitude: lat, longitude: lng };
};

export { getClientCoordinates };
